import renderDueDateMenuPickerAsCalloutWithOptions from './renderDueDateMenuPickerAsCalloutWithOptions';
import { IContextualMenuProps } from '@fluentui/react/lib/ContextualMenu';

export default function renderDueDateMenuPickerAsCallout(item?: IContextualMenuProps) {
    return renderDueDateMenuPickerAsCalloutWithOptions(item);
}
